import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Platform, View } from 'react-native';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { IShareViewModelType } from './IShareViewModel';
import { EmailShareButton, FacebookShareButton, FacebookMessengerShareButton, HatenaShareButton, InstapaperShareButton, LineShareButton, LinkedinShareButton, LivejournalShareButton, MailruShareButton, OKShareButton, PinterestShareButton, PocketShareButton, RedditShareButton, TelegramShareButton, TumblrShareButton, TwitterShareButton, ViberShareButton, VKShareButton, WhatsappShareButton, WorkplaceShareButton, EmailIcon, FacebookIcon, FacebookMessengerIcon, HatenaIcon, InstapaperIcon, LineIcon, LinkedinIcon, LivejournalIcon, MailruIcon, OKIcon, PinterestIcon, PocketIcon, RedditIcon, TelegramIcon, TumblrIcon, TwitterIcon, ViberIcon, VKIcon, WhatsappIcon, WorkplaceIcon } from 'react-share';
import { CoreConfig } from '../../../CoreConfig';
import { Shadow } from '../../Styles/Shadow';
import { component } from '../../Decorators/Component';
import { SmallView } from '../Typography/SmallView';
import { SecondaryButtonView } from '../Buttons/SecondaryButtonView';
import { createSectionView } from '../Common/SectionView';
const SocialComponents = {
    unknown: (props) => null,
    copy: (props) => null,
    email: (props) => (_jsx(EmailShareButton, Object.assign({}, props, { children: _jsx(EmailIcon, { size: props.size }) }))),
    facebook: (props) => (_jsx(FacebookShareButton, Object.assign({}, props, { children: _jsx(FacebookIcon, { size: props.size }) }))),
    messenger: (props) => (_jsx(FacebookMessengerShareButton, Object.assign({}, props, { children: _jsx(FacebookMessengerIcon, { size: props.size }) }))),
    hatena: (props) => (_jsx(HatenaShareButton, Object.assign({}, props, { children: _jsx(HatenaIcon, { size: props.size }) }))),
    instapaper: (props) => (_jsx(InstapaperShareButton, Object.assign({}, props, { children: _jsx(InstapaperIcon, { size: props.size }) }))),
    line: (props) => (_jsx(LineShareButton, Object.assign({}, props, { children: _jsx(LineIcon, { size: props.size }) }))),
    linkedin: (props) => (_jsx(LinkedinShareButton, Object.assign({}, props, { children: _jsx(LinkedinIcon, { size: props.size }) }))),
    livejournal: (props) => (_jsx(LivejournalShareButton, Object.assign({}, props, { children: _jsx(LivejournalIcon, { size: props.size }) }))),
    mailru: (props) => (_jsx(MailruShareButton, Object.assign({}, props, { children: _jsx(MailruIcon, { size: props.size }) }))),
    ok: (props) => (_jsx(OKShareButton, Object.assign({}, props, { children: _jsx(OKIcon, { size: props.size }) }))),
    pinterest: (props) => (_jsx(PinterestShareButton, Object.assign({}, props, { children: _jsx(PinterestIcon, { size: props.size }) }))),
    pocket: (props) => (_jsx(PocketShareButton, Object.assign({}, props, { children: _jsx(PocketIcon, { size: props.size }) }))),
    reddit: (props) => (_jsx(RedditShareButton, Object.assign({}, props, { children: _jsx(RedditIcon, { size: props.size }) }))),
    telegrams: (props) => (_jsx(TelegramShareButton, Object.assign({}, props, { children: _jsx(TelegramIcon, { size: props.size }) }))),
    tumblr: (props) => (_jsx(TumblrShareButton, Object.assign({}, props, { children: _jsx(TumblrIcon, { size: props.size }) }))),
    twitter: (props) => (_jsx(TwitterShareButton, Object.assign({}, props, { children: _jsx(TwitterIcon, { size: props.size }) }))),
    viber: (props) => (_jsx(ViberShareButton, Object.assign({}, props, { children: _jsx(ViberIcon, { size: props.size }) }))),
    vk: (props) => (_jsx(VKShareButton, Object.assign({}, props, { children: _jsx(VKIcon, { size: props.size }) }))),
    whatsapp: (props) => (_jsx(WhatsappShareButton, Object.assign({}, props, { children: _jsx(WhatsappIcon, { size: props.size }) }))),
    workplace: (props) => (_jsx(WorkplaceShareButton, Object.assign({}, props, { children: _jsx(WorkplaceIcon, { size: props.size }) }))),
};
const SocialText = {
    unknown: '',
    copy: '',
    email: 'Email',
    facebook: 'Facebook',
    messenger: 'Messenger',
    hatena: 'Hatena',
    instapaper: 'Instapaper',
    line: 'Line',
    linkedin: 'Linkedin',
    livejournal: 'Live',
    mailru: 'Mail',
    ok: 'Ok',
    pinterest: 'Pinterest',
    pocket: 'Pocket',
    reddit: 'Reddit',
    telegrams: 'Telegrams',
    tumblr: 'Tumblr',
    twitter: 'Twitter',
    viber: 'Viber',
    vk: 'Vk',
    whatsapp: 'Whatsapp',
    workplace: 'Workplace'
};
const SocialsSection = createSectionView(({ value, onPress, containerStyle, textStyle }) => {
    const Component = SocialComponents[value.key] || (() => null);
    const text = SocialText[value.key] || '';
    return (_jsxs(_Fragment, { children: [_jsx(View, { style: containerStyle, children: _jsx(Component, Object.assign({}, value.params, { onShareWindowClose: () => onPress === null || onPress === void 0 ? void 0 : onPress(value), style: { height: '100%', width: '100%' }, url: value.text, size: containerStyle === null || containerStyle === void 0 ? void 0 : containerStyle.height })) }), _jsx(SmallView, { textStyle: textStyle, children: text })] }));
});
export const ShareComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.share,
    dependencies: {
        viewModel: IShareViewModelType
    },
    style: {
        container: {},
        interactions: {
            marginTop: 10,
        },
        item: Object.assign({ overflow: 'hidden', borderRadius: 100, height: 70, width: 70, alignSelf: 'center' }, Shadow.level(1)),
        content: {
            padding: 6,
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            borderWidth: 1,
            borderStyle: 'dashed',
            borderColor: '#B8BDC7',
            borderRadius: 8
        },
        interactionsText: {
            marginTop: 5,
            marginBottom: 0,
            textAlign: 'center'
        },
        text: {
            flex: 1
        }
    }
})(({ text, onPress, viewModel, style, localization, options, containerStyle }) => {
    const items = useMemo(() => { var _a; return (((_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData) === null || _a === void 0 ? void 0 : _a.options) || []).map(item => (Object.assign(Object.assign({}, item), { text, id: item.key, params: Object.assign(Object.assign({}, item.params), options) }))); }, [text, viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.options, options]);
    const handlePress = useCallback((option) => {
        if (!text) {
            return;
        }
        viewModel === null || viewModel === void 0 ? void 0 : viewModel.onPress(text, option).then(() => onPress === null || onPress === void 0 ? void 0 : onPress(option));
    }, [text, onPress]);
    const handleShare = useCallback(() => {
        if (!text) {
            return;
        }
        viewModel === null || viewModel === void 0 ? void 0 : viewModel.share(text, options).then((option) => onPress === null || onPress === void 0 ? void 0 : onPress(option));
    }, [text, options, onPress]);
    if (!text) {
        return null;
    }
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyle], children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.text, numberOfLines: 1, ellipsizeMode: "tail", children: text }), _jsx(SecondaryButtonView, { wrapperStyle: { maxWidth: 90 }, text: Platform.select({
                            default: (localization === null || localization === void 0 ? void 0 : localization.share) || 'Share',
                            web: (localization === null || localization === void 0 ? void 0 : localization.copy) || 'Copy'
                        }), onPress: handleShare })] }), ((viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.options) || []).length > 0 && (_jsx(SocialsSection, { values: items, hideButtons: true, containerStyle: style === null || style === void 0 ? void 0 : style.interactions, itemStyle: { margin: 10 }, contentStyle: { paddingTop: 0 }, itemProps: { containerStyle: style === null || style === void 0 ? void 0 : style.item, textStyle: style === null || style === void 0 ? void 0 : style.interactionsText }, onPress: handlePress }))] }));
});
